export default [
  'Length',
  'EllipticalROI',
  'Bidirecional',
  'ArrowAnnotate',
  'Angle',
  'CobbAngle',
  'Probe',
  'RectangleROI',
  'PlanarFreehandROI',
];
